import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {HttpClient, HttpClientModule , HttpHeaders} from '@angular/common/http' ;
import {AppConstant} from './app/AppConstant'
import { Address } from './app/address/address.model';
import { getOtp } from './app/login/getOtpRequest';
import { Order } from './app/order/order.model'

@Injectable({
  providedIn: 'root'
})


export class SharingDataService {

  constructor(public httpClient : HttpClient ) { }

  Get_Customers= 'customers';
  add_Address='address/addAddress';
  sendotp='send-otp';
  male_products='maleProducts';
  female_products='femaleProducts';
  verifyotp='verify-otp';
  optUrl='api/auth/';
 emailurl='send'
 order='order/';
 deleteOrder='deleteOrder/'
 addOrder='addOrder'
 cart='cart/';
 customer='customer/'
 addressbyaddressId='addressbyaddressId/'
 addressbyCustomerId='addressbyCustomerId/'
 deleteAddress='deleteAddress/'
 updateCart= 'updateCart'
 updateOrder='updateOrder'

  private valueSource = new BehaviorSubject<Object>('default');
  currentValue = this.valueSource.asObservable();

  updateValue(val: {}) {
    this.valueSource.next(val);
  }

   private loggedInCustomerId = new BehaviorSubject<any>(null);
  loggedInCustomerIdVal = this.loggedInCustomerId.asObservable();

  getloggedInCustomerId(val: number) {
    this.loggedInCustomerId.next(val);
  }

  private localCart = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('cart') || '[]'));
  getlocalCart = this.localCart.asObservable();


  getlocalStorageCart(val: any) {
     localStorage.setItem('cart', JSON.stringify(val));
    this.localCart.next(val);
  }

  
  
  GetAllCustomers(){
    console.log("In Sharing service");
    console.log(AppConstant.baseURL + this.Get_Customers);
    return this.httpClient.get(AppConstant.baseURL + this.Get_Customers)
  }

  addAddress(address: Address){
    console.log("In address sharingservice");
    console.log(AppConstant.baseURL + this.add_Address);
    return this.httpClient.post(AppConstant.baseURL + this.add_Address,address)
  }

  getAddressByAddressId(addressId:number){
    console.log(AppConstant.baseURL + this.addressbyaddressId + addressId);
    return this.httpClient.get(AppConstant.baseURL + this.addressbyaddressId + addressId);
  }

    getAddressByCustomerId(customerId:number){
    console.log(AppConstant.baseURL + this.addressbyCustomerId + customerId);
    return this.httpClient.get(AppConstant.baseURL + this.addressbyCustomerId + customerId);
  }

  
    deleteAddressByAddressId(addressId:number){
    console.log(AppConstant.baseURL + this.deleteAddress + addressId);
    return this.httpClient.delete(AppConstant.baseURL + this.deleteAddress + addressId);
  }

  getOtp(getotp : getOtp){
    console.log("In get otp common service");
    console.log(AppConstant.baseURL + this.optUrl +this.sendotp);
     //return this.httpClient.post(AppConstant.baseURL + this.optUrl + this.sendotp,getotp)
    return this.httpClient.post(AppConstant.baseURL + this.optUrl +this.sendotp,getotp)
  }

    verifyOtp(email: string, otp: string) {
    return this.httpClient.post(AppConstant.baseURL +this.optUrl + this.verifyotp, null, {
      params: { email, otp },
      responseType: 'text' // JWT is returned as plain text
    });
  }

  GetAllMaleProducts(){
    console.log("In Sharing service");
    console.log(AppConstant.baseURL + this.male_products);
    return this.httpClient.get(AppConstant.baseURL + this.male_products)
  }

  GetAllFemaleProducts(){
    console.log("In Sharing service");
    console.log(AppConstant.baseURL + this.female_products);
    return this.httpClient.get(AppConstant.baseURL + this.female_products)
  }

   addOrderFn(order: any){
    console.log("Adding Order");
    console.log(AppConstant.baseURL + this.order + this.addOrder);
    return this.httpClient.post(AppConstant.baseURL + this.order + this.addOrder,order)
  }

  getOrderbyOrderId(orderId:number){
    console.log("In getOrderbyOrderId");
    console.log(AppConstant.baseURL + this.order + orderId);
    return this.httpClient.get(AppConstant.baseURL + this.order + orderId);
  }

   getOrderbyCartId(cartId:number){
    console.log("In getOrderbyCartId");
    console.log(AppConstant.baseURL + this.order + this.cart +  cartId);
    return this.httpClient.get(AppConstant.baseURL + this.order +  this.cart + cartId);
  }

   getOrderbyCustomerId(CustomerId:number){
    console.log("In getOrderbyCustomerId");
    console.log(AppConstant.baseURL + this.order + this.customer + CustomerId);
    return this.httpClient.get(AppConstant.baseURL + this.order + this.customer + CustomerId);
  }

  updateCartFn(cart:any){
     console.log(AppConstant.baseURL + this.cart + this.updateCart);
     return this.httpClient.put(AppConstant.baseURL + this.cart + this.updateCart,cart);

  }

   updateOrderFn(order:any){
     console.log(AppConstant.baseURL + this.order + this.updateOrder);
     return this.httpClient.put(AppConstant.baseURL + this.order + this.updateOrder,order);

  }
  

}


